export const navLinks = [
    { name: "Mind", href: "/mind", hideOnMind: true },
    { name: "Lab", href: "/lab", hideOnMind: true },
    {
        name: "Organizations",
        children: [
            {
                name: "First Responder Peer Support",
                href: "https://peersupport.keelmind.com/",
                target: "_blank",
                rel: "noreferrer",
            },
        ],
    },
    { name: "About Us", href: "/about-us" },
    { name: "Our Team", href: "/our-team" },
    {
        name: "Resources & News",
        children: [
            { name: "Resource Centre", href: "/mind/resource-centre" },
            {
                name: "News Room",
                href: "/mind/news",
            },
        ],
        hideOnDigital: true,
    },
    // { name: "Contact us", href: "/contact-us", hamburgerOnly: true },
];

export const footerLinks = [
    {
        name: "Company",
        children: [
            {
                name: "Mind",
                href: "/mind",
            },
            {
                name: "Lab",
                href: "/lab",
            },
            { name: "About Us", href: "/about-us" },
            { name: "Our Team", href: "/our-team" },

            // {
            //     name: "Keelmind.com",
            //     href: "https://keelmind.com",
            //     target: "_blank",
            // },
        ],
    },
    {
        name: "Legal",
        children: [
            { name: "Privacy Policy", href: "/mind/privacy-policy" },
            {
                name: "Terms of Use",
                href: "/mind/terms-of-use",
            },
            {
                name: "Terms & Conditions",
                href: "/mind/terms-and-conditions",
            },
        ],
    },
    {
        name: "Support",
        children: [
            { name: "Platform Support", href: "/mind/support-directory" },
            { name: "Security", href: "/mind/security" },
            { name: "FAQs", href: "/mind/faq" },
        ],
    },
    // {
    //     name: "Contact us",
    //     children: [
    //         { name: "admin@keel.digital", href: "mailto:admin@keel.digital" },
    //     ],
    // },
];

export const supportDirectoryLinks = [
    { text: "Crisis Support", href: "/crisis-support" },
    {
        text: "Technical Support",
        href: "https://geta-head.zendesk.com/hc/en-us",
        target: "_blank",
        rel: "noreferrer",
    },
    {
        text: "Supported Browser & System Requirements",
        href: "https://geta-head.zendesk.com/hc/en-us/articles/8217573426189",
        target: "_blank",
        rel: "noreferrer",
    },
];
